import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { Draft } from "immer";

export interface ProductFiltersExtended extends ProductFilters {
    isInStockAtBranch?: boolean
}

export interface ProductListIsStockAvailableState {
    productFiltersExtended: ProductFiltersExtended;
}

const initialState: ProductListIsStockAvailableState = {
    productFiltersExtended: {
        isInStockAtBranch: undefined,
    }
};

const ProductListIsStockAvailableReducer = {
    "Custom/ProductList/IsStockAvailable/SetIsInStockAtBranch": (
        draft: Draft<ProductListIsStockAvailableState>,
        action: {
            data: ProductFiltersExtended;
        },
    ) => {
        draft.productFiltersExtended.isInStockAtBranch = action.data.isInStockAtBranch;
    },
};

export default createTypedReducerWithImmer(initialState, ProductListIsStockAvailableReducer);
